import I from '../types.ts';

const getArticlesItems: I['getArticlesItems'] = function () {
    const { items = [] } = this.state;

    return [...items, { _id: 'info', counter: items.length }];
};

export default getArticlesItems;
